import { Component, ElementRef, EventEmitter, inject, Input, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FileService, UploadedFile } from "@app/services";
import { from, of, Subscription } from "rxjs";
import { catchError, concatMap, tap } from "rxjs/operators";

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"],
  standalone: false
})
export class FileUploadComponent implements OnInit {

  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<FileUploadComponent>);
  fileService = inject(FileService);

  @Input() type: string;
  onSend = new EventEmitter<boolean>();
  sendedFile = new EventEmitter<UploadedFile>();

  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  @ViewChild("uploadBar") uploadBar: any;
  files: any[] = [];
  uploadProgress: number;
  uploadingFile: File;
  loading = false;
  uploadingFileCount = 0;
  private uploadSub: Subscription | null = null;

  ngOnInit() { }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(event) {
    this.prepareFilesList(event.target.files);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = null;
      this.files.push(item);
    }
    this.fileDropEl.nativeElement.value = "";
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }
  getIcon(type: string): string {
    return this.fileService.getFileIcon(type)
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  cancel() {
    this.uploadSub?.unsubscribe();
    this.dialogRef.close();
  }

  add() {
    if (this.loading) return;
    this.loading = true;
    this.uploadingFileCount = this.files.length;
    this.uploadSub = from([...this.files]).pipe(
      concatMap((file: any) => {
        file.progress = 0;
        file.status = 'uploading';
        return this.uploadFile(file);
      })
    ).subscribe({
      complete: () => {
        this.loading = false;
        if (this.files.every(f => f.status === 'success')) {
          this.dialogRef.close();
        }
      }
    });
  }

  retryFile(file: any) {
    file.progress = 0;
    file.status = 'uploading';
    this.uploadFile(file).subscribe({
      complete: () => {
        if (this.files.every(f => f.status === 'success')) {
          this.dialogRef.close();
        }
      }
    });
  }

  private uploadFile(file: any) {
    const formData = new FormData();
    formData.set("file", file);
    formData.set("type", file.type);
    formData.set("idRepertoire", this.data.idRepertoire);
    return this.fileService.upload(formData).pipe(
      tap((resp: any) => {
        if (typeof resp === "object" && "type" in resp) {
          file.progress = 100;
          file.status = 'success';
          this.uploadingFileCount--;
          this.sendedFile.emit(resp);
        } else if (resp.status === "progress") {
          file.progress = resp.message;
        }
        this.onSend.emit(true);
      }),
      catchError(() => {
        file.status = 'error';
        file.progress = null;
        this.uploadingFileCount--;
        return of(null);
      })
    );
  }
}
